import { InizioPagina } from '@components/servizi-soluzioni/inizio-pagina/inizio-pagina';
import { useIntl } from 'react-intl';
import { Navbar as PageNavbar } from '@components/servizi-soluzioni/navbar/navbar';
import { Container } from '@components/servizi-soluzioni/container/container';
import { ScrollToTop } from '@components/servizi-soluzioni/scroll-to-top/scroll-to-top';
import cn from 'classnames';
import { useLayoutBreakpoint } from '@hooks/use-layout-breakpoint';
import { useState } from 'react';
import { PageHead } from '../../common/head/page-head';
import { Navbar } from '../../common/navbar/navbar';
import styles from './desktop.module.css';
import { AziendaStoria } from '../storia/storia';
import { AziendaMission } from '../mission/misson';
import { AziendaOrganizzazione } from '../organizzazione/organizzazione';
import { AziendaManagement } from '../management';
import { AziendaCertificazioni } from '../certificazioni';
import { AziendaStoriaMobile } from '../storia/mobile';
import { AziendaMissionMobile } from '../mission/misson-mobile';
import { AziendaOrganizzazioneMobile } from '../organizzazione/mobile/mobile';

export default function AziendaDesktop({
  mainSectionDescriptions = {},
  mainSectionImageUrl = '',
  mainSectionDarkTheme = false,
  navbarItems = [],
  serviceCategories = [],
  technologyCategories = []
}) {
  const intl = useIntl();
  const breakpoint = useLayoutBreakpoint();
  const [navMobileState, setNavMobileState] = useState({ isOpen: false });

  if (!breakpoint) {
    return null;
  }
  const isMobile = ['xs', 'sm', 'md'].indexOf(breakpoint) >= 0;
  return (
    <div className="snf-lx-components-azienda-desktop-desktop" style={{ display: 'contents' }}>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: "Sistemi Informativi S.r.l. - An IBM company - L' Azienda",
          description: "L' Azienda - Page title"
        })}
        description={intl.formatMessage({
          defaultMessage: "Sistemi Informativi S.r.l. - L'Azienda",
          description: "L'Azienda - Page description"
        })}
      />
      <Navbar
        navCssClasses={cn(`${styles.navbarBackground} position-absolute`, {
          noImgBackground: !mainSectionImageUrl
        })}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />
      <main role="main">
        <Container imageUrl={mainSectionImageUrl} darkTheme={mainSectionDarkTheme}>
          <InizioPagina translations={mainSectionDescriptions} darkTheme={mainSectionDarkTheme} />
          <PageNavbar
            selectedNavItem={navMobileState}
            onNavItemClick={setNavMobileState}
            navbarItems={navbarItems}
          />
        </Container>
        <div>
          {!isMobile ? (
            <>
              <AziendaMission />
              <AziendaStoria />
              <AziendaOrganizzazione />
            </>
          ) : (
            <>
              <AziendaMissionMobile />
              <AziendaStoriaMobile />
              <AziendaOrganizzazioneMobile />
            </>
          )}
          <AziendaManagement />
          <AziendaCertificazioni />
          <ScrollToTop onClick={() => setNavMobileState({ isOpen: false })} />
        </div>
      </main>
    </div>
  );
}
